<template>
   <div class="row justify-content-center product-additional-info">
      <div class="col-md-12 col-lg-12">
         <div class="card p-4">
            <!-- Ingredients Section -->
            <div>
            <h5 class="section-title">Ingredients & Composition</h5>
            <p class="mb-0">Does not contain:</p>
            <ul class="mt-2">
               <li>Eggs</li>
               <li>Alcohol</li>
               <li>Gelatine</li>
               <li>Animal-based colours and essences</li>
            </ul>
            </div>

            <!-- Note Section -->
            <div class="note">
            <h5 class="section-title">Please Note</h5>
            <ul>
               <li>The cake stand, cutlery & accessories used in the image are only for representation purposes and are not delivered with the cake.</li>
               <li>This cake is hand delivered in high-quality, food-grade boxes which may contain our brand logo and other information.</li>
            </ul>
            </div>

            <!-- Delivery Information -->
            <div class="delivery">
            <h5 class="section-title">Delivery Information</h5>
            <ul>
               <li>Every cake is handcrafted; slight variations in design and shape may occur.</li>
               <li>The chosen delivery time is an estimate and depends on product availability and destination.</li>
               <li>Since cakes are perishable, delivery is attempted only once and cannot be redirected.</li>
               <li>This product is hand-delivered and will not be sent with courier items.</li>
               <li>Occasionally, flavour or design substitutions may occur due to temporary or regional unavailability.</li>
            </ul>
            </div>

            <!-- Care Instructions -->
            <div class="care">
            <h5 class="section-title">Care Instructions</h5>
            <ul>
               <li>Store cakes in a refrigerator as soon as they are received. Do not keep them in packaging.</li>
               <li>Fondant or Sugar Paste cakes should be stored in a cool or air-conditioned environment.</li>
               <li>Slice and serve at room temperature, avoiding heat exposure.</li>
               <li>Use a serrated knife to cut fondant cakes.</li>
               <li>Check for food-grade supports (wires or skewers) before serving to children.</li>
               <li>Consume the cake within 12 hours for best taste and freshness.</li>
               <li>Cake may contain food colouring that can temporarily stain hands or mouth but is safe for consumption.</li>
               <li>Enjoy your cake!</li>
            </ul>
            </div>       
         </div>
      </div>
   </div>  
</template>
<style scopped>
.product-additional-info .card {
   border: none;
   border-radius: 12px;
   box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}

.product-additional-info .section-title {
   font-size: 1.25rem;
   font-weight: 600;
   color: #343a40;
   border-left: 4px solid #dc3545;
   padding-left: 10px;
   margin-top: 1.5rem;
   margin-bottom: 0.75rem;
}

.product-additional-info ul {
   list-style: none;
   padding-left: 0;
}

.product-additional-info ul li::before {
   content: "✔️";
   margin-right: 8px;
   color: #198754;
}

.note, .delivery, .care {
   margin-top: 1.5rem;
}
</style>